import { api } from "@agroproj/backend/convex/_generated/api";
import type { Id } from "@agroproj/backend/convex/_generated/dataModel";
import { useQuery } from "convex/react";
import { useMemo } from "react";

/**
 * Active banks as select options ("code - title"). Keeps the selected bank in the list when it
 * has since been deactivated, so an existing project still shows its bank.
 */
export function useBankOptions(selectedBankId: string | undefined) {
  const banks = useQuery(api.base.queries.getBanks, { activeOnly: true });
  const selectedBank = useQuery(
    api.base.queries.getBankById,
    selectedBankId ? { bankId: selectedBankId as Id<"base_banks"> } : "skip",
  );

  return useMemo(() => {
    const mergedBanks = banks ? [...banks] : [];

    if (selectedBank && !mergedBanks.some((bank) => bank._id === selectedBank._id)) {
      mergedBanks.push(selectedBank);
      mergedBanks.sort((left, right) => left.code.localeCompare(right.code, "pt-BR"));
    }

    return mergedBanks.map((bank) => ({
      value: bank._id,
      label: `${bank.code} - ${bank.title}`,
    }));
  }, [banks, selectedBank]);
}
